export default __webpack_public_path__ + "static/media/image-exclusive-forum.86e500dc.png";